// `d.toISOString().slice(0, 10)` looks like it extracts "today's date", but
// toISOString() always converts to UTC first — for any positive-UTC-offset
// timezone (e.g. IST, +5:30) that reads back as the PREVIOUS calendar day
// for roughly the first ~5-6 hours of each local day, and reliably one day
// early for any Date built from local y/m/d components (new Date(y, m, d) is
// local midnight, which is already "yesterday" in UTC terms). Use this
// instead wherever the goal is "the calendar date this Date represents",
// not "the UTC instant".
export function toLocalISODate(d) {
  const date = new Date(d);
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
